// src/components/analytics/analytics-meta.ts
/**
 * Costanti condivise per i grafici analytics: label, colori (hex per recharts,
 * nome colore Mantine per i Badge) e helper per tipologie/stati.
 */

import { RequestStatus, RequestType } from '../../types/api';

export const TYPE_META: Record<
  RequestType,
  { label: string; color: string; mantineColor: string; route: string }
> = {
  [RequestType.Bozzetto]: { label: 'Bozzetti', color: '#228BE6', mantineColor: 'blue', route: '/bozzetti' },
  [RequestType.Campionatura]: { label: 'Campionatura', color: '#FAB005', mantineColor: 'yellow', route: '/campioni' },
  [RequestType.Produzione]: { label: 'Produzione', color: '#40C057', mantineColor: 'green', route: '/produzione' },
  [RequestType.Gamma]: { label: 'Gamma', color: '#7950F2', mantineColor: 'violet', route: '/gamma' },
};

export const STATUS_META: Record<
  RequestStatus,
  { label: string; color: string; mantineColor: string }
> = {
  [RequestStatus.New]: { label: 'Nuove', color: '#228BE6', mantineColor: 'blue' },
  [RequestStatus.PreCampionatura]: { label: 'In Pre-Campionatura', color: '#9C36B5', mantineColor: 'grape' },
  [RequestStatus.PreCampionaturaCompleted]: { label: 'Pre-Campionatura Completata', color: '#4263EB', mantineColor: 'indigo' },
  [RequestStatus.InProgress]: { label: 'In Lavorazione', color: '#15AABF', mantineColor: 'cyan' },
  [RequestStatus.PendingCompletion]: { label: 'In Attesa', color: '#FAB005', mantineColor: 'yellow' },
  [RequestStatus.Completed]: { label: 'Completate', color: '#40C057', mantineColor: 'green' },
  [RequestStatus.Cancelled]: { label: 'Annullate', color: '#FA5252', mantineColor: 'red' },
  [RequestStatus.Suspended]: { label: 'Sospese', color: '#868E96', mantineColor: 'gray' },
};

export const ALL_TYPES: RequestType[] = [
  RequestType.Bozzetto,
  RequestType.Campionatura,
  RequestType.Produzione,
  RequestType.Gamma,
];

export const ALL_STATUSES: RequestStatus[] = [
  RequestStatus.New,
  RequestStatus.PreCampionatura,
  RequestStatus.PreCampionaturaCompleted,
  RequestStatus.InProgress,
  RequestStatus.PendingCompletion,
  RequestStatus.Suspended,
  RequestStatus.Completed,
  RequestStatus.Cancelled,
];

export function typeLabel(type: RequestType): string {
  return TYPE_META[type]?.label ?? `Tipo ${type}`;
}

export function statusLabel(status: RequestStatus): string {
  return STATUS_META[status]?.label ?? `Stato ${status}`;
}

/** Path frontend del dettaglio richiesta (usato per aprire in una nuova tab). */
export function requestDetailPath(id: number): string {
  return `/requests/${id}`;
}

/**
 * Serie dei grafici "Tempi di completamento": le 4 tipologie più la fase di
 * Pre-Campionatura (estratta dalla Campionatura, misurata separatamente).
 */
export type SeriesKey = RequestType | 'pre';

export const ALL_SERIES: SeriesKey[] = [...ALL_TYPES, 'pre'];

export const SERIES_META: Record<SeriesKey, { label: string; color: string; mantineColor: string }> = {
  ...TYPE_META,
  pre: { label: 'Pre-Campionatura', color: '#9C36B5', mantineColor: 'grape' },
} as Record<SeriesKey, { label: string; color: string; mantineColor: string }>;

export function seriesLabel(series: SeriesKey): string {
  return SERIES_META[series]?.label ?? `Serie ${series}`;
}
